/**
 * Minimal inline icon set (stroke-based, currentColor) so we don't add an icon dependency.
 * In the real monorepo, lucide-react / the restos-waiter icon layer would be used instead.
 */
import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement> & { size?: number };

function base({ size = 16, ...props }: IconProps) {
  return {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
    ...props,
  };
}

export const PlayIcon = (p: IconProps) => (
  <svg {...base(p)} aria-hidden="true">
    <polygon points="6 4 20 12 6 20 6 4" fill="currentColor" stroke="none" />
  </svg>
);

export const CheckIcon = (p: IconProps) => (
  <svg {...base(p)} aria-hidden="true">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

export const CheckCircleIcon = (p: IconProps) => (
  <svg {...base(p)} aria-hidden="true">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);

export const CircleIcon = (p: IconProps) => (
  <svg {...base(p)} aria-hidden="true">
    <circle cx="12" cy="12" r="9" fill="currentColor" stroke="none" />
  </svg>
);

export const AlertIcon = (p: IconProps) => (
  <svg {...base(p)} aria-hidden="true">
    <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

export const ClockIcon = (p: IconProps) => (
  <svg {...base(p)} aria-hidden="true">
    <circle cx="12" cy="12" r="9" />
    <polyline points="12 7 12 12 15 14" />
  </svg>
);

export const XIcon = (p: IconProps) => (
  <svg {...base(p)} aria-hidden="true">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

export const TrendUpIcon = (p: IconProps) => (
  <svg {...base(p)} aria-hidden="true">
    <polyline points="3 17 9 11 13 15 21 7" />
    <polyline points="15 7 21 7 21 13" />
  </svg>
);

export const TrendDownIcon = (p: IconProps) => (
  <svg {...base(p)} aria-hidden="true">
    <polyline points="3 7 9 13 13 9 21 17" />
    <polyline points="15 17 21 17 21 11" />
  </svg>
);

export const WifiOffIcon = (p: IconProps) => (
  <svg {...base(p)} aria-hidden="true">
    <line x1="1" y1="1" x2="23" y2="23" />
    <path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55" />
    <path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39" />
    <path d="M10.71 5.05A16 16 0 0 1 22.58 9" />
    <path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88" />
    <path d="M8.53 16.11a6 6 0 0 1 6.95 0" />
    <line x1="12" y1="20" x2="12.01" y2="20" />
  </svg>
);
